import { render, staticRenderFns } from "./InstitutePageSidebar.vue?vue&type=template&id=2ea8658a"
import script from "./InstitutePageSidebar.vue?vue&type=script&lang=js"
export * from "./InstitutePageSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports